import { render, staticRenderFns } from "./DotMenu.vue?vue&type=template&id=30a31e15&scoped=true&"
import script from "./DotMenu.vue?vue&type=script&lang=js&"
export * from "./DotMenu.vue?vue&type=script&lang=js&"
import style0 from "./DotMenu.vue?vue&type=style&index=0&id=30a31e15&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a31e15",
  null
  
)

export default component.exports